// src/components/MainLayout.js

import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header"; // Adjust the path to your Header component
import Footer from "../Footer/TestFooter.js"; // Adjust the path to your Footer component

// You can place the required CSS in App.css or a dedicated Layout.css file
// .app-container { display: flex; flex-direction: column; min-height: 100vh; }
// .main-content { flex-grow: 1; }

export function MainLayout() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  return (
    <div className="app-container">
      {userInfo ? <Header variant="light" /> : <Header variant="light" />}
      <main className="main-content">
        {/* The Outlet component will render the matched child route component */}
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
